import { render } from "./MultipleFormElement.vue?vue&type=template&id=336860b7"
import script from "./MultipleFormElement.vue?vue&type=script&lang=js"
export * from "./MultipleFormElement.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omniadmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__